module.exports = __webpack_public_path__ + "img/2.8da20b14.png";